// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ExpandIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4412 14.6583C11.4278 14.6583 10.6412 15.4449 10.6412 16.4583V35.4583C10.6412 36.4717 11.4278 37.2583 12.4412 37.2583H31.4412C32.4546 37.2583 33.2412 36.4717 33.2412 35.4583V20.4583C33.2412 20.0717 33.5546 19.7583 33.9412 19.7583C34.3278 19.7583 34.6412 20.0717 34.6412 20.4583V35.4583C34.6412 37.2449 33.2278 38.6583 31.4412 38.6583H12.4412C10.6546 38.6583 9.24121 37.2449 9.24121 35.4583V16.4583C9.24121 14.6717 10.6546 13.2583 12.4412 13.2583H27.0412C27.4278 13.2583 27.7412 13.5717 27.7412 13.9583C27.7412 14.3449 27.4278 14.6583 27.0412 14.6583H12.4412Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3252 9.9417C29.3252 9.5551 29.6386 9.2417 30.0252 9.2417H37.0252C37.9618 9.2417 38.7252 10.0051 38.7252 10.9417V17.9417C38.7252 18.3283 38.4118 18.6417 38.0252 18.6417C37.6386 18.6417 37.3252 18.3283 37.3252 17.9417V10.9417C37.3252 10.7783 37.1886 10.6417 37.0252 10.6417H30.0252C29.6386 10.6417 29.3252 10.3283 29.3252 9.9417Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.7395 10.0528C38.0106 10.3284 38.007 10.7716 37.7315 11.0427L22.2315 26.2927C21.9559 26.5639 21.5127 26.5603 21.2415 26.2847C20.9704 26.0091 20.974 25.5659 21.2496 25.2948L36.7496 10.0448C37.0252 9.77363 37.4684 9.77724 37.7395 10.0528Z"
      fill="currentColor"
    />
  </Icon>
);
